// Each module in this file should be considered independent of
// templates or individual routes. Instead, each module should be
// dynamically imported based on a test criteria such as the 
// presence of a DOM element with a given data attribute. 

// This file is loaded globally but should just contain dynamically 
// loaded module logic only.

// --------------------------------
// Import and execute the global JS
// --------------------------------
import('./main')
	.then(({ mainJs }) => {
		mainJs()
	})

// --------------------------------
// Carousels "Testimonials"
// --------------------------------
const carouselsTesti = document.querySelectorAll('[data-module="testimonials-carousel"]')

if (carouselsTesti.length > 0) {
	import('./components/carousel-testimonials')
		.then(({ carouselTestimonials }) => {
			carouselsTesti.forEach(carouselEl => {
				carouselTestimonials(carouselEl)
			})
		});
}

// --------------------------------
// Carousels for mobile indusries page section "How we help"
// --------------------------------
const carousels = document.querySelectorAll('[data-module="help-carousel"]')

if (carousels.length > 0) {
	import('./components/carousel-mobile')
		.then(({ carouselMobile }) => {
			carousels.forEach(carouselEl => {
				carouselMobile(carouselEl)
			})
		});
}

// --------------------------------
// Carousels for News on page section "Industries"
// --------------------------------
const carouselsNewsItems = document.querySelectorAll('[data-module="news-carousel"]')

if (carouselsNewsItems.length > 0) {
	import('./components/carousel-news')
		.then(({ carouselNews }) => {
			carouselsNewsItems.forEach(carouselEl => {
				carouselNews(carouselEl)
			})
		});
}

// --------------------------------
// Player video for lightbox in Industries page section "See how it works"
// --------------------------------
const playersHome = document.querySelectorAll('[data-module="how-player"]')
const lightbox = document.querySelector('[data-module="how-lightbox"]')
const buttonTriggerHome = document.querySelector('.trigger-lightbox-how-it-works-js')

if (playersHome.length > 0) {
	import('./components/video-lightbox')
		.then(({ videoLightbox }) => {
			playersHome.forEach(video => {
				videoLightbox(video, buttonTriggerHome, lightbox)
			})
		});
}


// --------------------------------
// Player video for lightbox in Industries page section "See how it works"
// --------------------------------
const players = document.querySelectorAll('[data-module="hidden-player"]')
const wrapVideo = document.querySelector('[data-module="wrap-video"]')
const buttonTrigger = document.querySelector('.trigger-hidden-video-js')

if (players.length > 0) {
	import('./components/video-hidden')
		.then(({ videoHidden }) => {
			players.forEach(video => {
				videoHidden(video, buttonTrigger, wrapVideo)
			})
		});
}


// --------------------------------
// Player video for lightbox in Single article page section "Hero"
// --------------------------------
const articlePlayers = document.querySelectorAll('[data-module="article-player"]')
const articleLightbox = document.querySelector('[data-module="article-lightbox"]')
const buttonTriggerVideoArticle = document.querySelector('.trigger-lightbox-hero-article')

if (articlePlayers.length > 0) {
	import('./components/video-lightbox')
		.then(({ videoLightbox }) => {
			articlePlayers.forEach(video => {
				videoLightbox(video, buttonTriggerVideoArticle, articleLightbox)
			})
		});
}

// --------------------------------
// Faq Item click logic on Users page
// --------------------------------
const allFaqsStuffs = document.querySelectorAll('[data-module="faq-item"]')

if (allFaqsStuffs.length > 0) {
	import('./components/faq-item')
		.then(({ faqItem }) => {
			allFaqsStuffs.forEach(faq => {
				faqItem(faq)
			})
		});
}

// --------------------------------
// Carousels for Featured In on page section "Featured In"
// --------------------------------
const carouselsFeaturedIn = document.querySelectorAll('[data-module="featured-in-carousel"]')

if (carouselsFeaturedIn.length > 0) {
	import('./components/carousel-featured-in')
		.then(({ carouselFeaturedIn }) => {
			carouselsFeaturedIn.forEach(carouselEl => {
				carouselFeaturedIn(carouselEl)
			})
		});
}


// --------------------------------
// Why Armalytix video popup
// --------------------------------
const whyArmalytix = document.querySelectorAll('[data-module="why-armalytix"]')

if (whyArmalytix.length > 0) {
	import('./components/why-armalytix')
		.then(({ carouselFeaturedIn }) => {
			whyArmalytix.forEach(carouselEl => {
				carouselFeaturedIn(carouselEl)
			})
		});
}

// --------------------------------
// Player video for lightbox in Industries page section "See how it works"
// --------------------------------
// const playerWhy = document.querySelectorAll('[data-module="why-armalytix-player"]')
// const whyLightbox = document.querySelector('[data-module="why-armalytix-lightbox"]')
// const buttonTriggerWhy = document.querySelector('.trigger-lightbox-why-armalytix-js')
const whyItemsWithVideo = document.querySelectorAll('[data-module="why-armalytix-item"]')

if (whyItemsWithVideo.length > 0) {
	console.log(whyItemsWithVideo)
	import('./components/why-armalytix')
		.then(({ whyArmalytixLightbox }) => {
			whyItemsWithVideo.forEach(item => {
				const video = item.querySelector('[data-module="why-armalytix-player"]');
				const lightbox = item.querySelector('[data-module="why-armalytix-lightbox"]');
				const buttonTriggerWhy = item.querySelector('.trigger-lightbox-why-armalytix-js')
				whyArmalytixLightbox(video, buttonTriggerWhy, lightbox)
			})
		});
}



// --------------------------------
// Carousels for mobile indusries page section "How we help"
// --------------------------------
// const carousels = document.querySelectorAll('[data-module="reports-carousel"]')

// if (carousels.length > 0) {
// 	import('./components/carousel-mobile')
// 	.then(({ carouselMobile }) => {
// 		carousels.forEach(carouselEl => {
// 				carouselMobile(carouselEl)
// 			})
// 		});
// }


// --------------------------------
// Example: Testimonial carousels 
// --------------------------------
// const testimonials = document.querySelectorAll('[data-module="testimonials"]')

// if (testimonials.length > 0) {
//   import('./components/testimonials')
//     .then(({ carousel }) => {
// 			testimonials.forEach(carouselEl => {
// 				carousel(carouselEl)
// 			})
// 		})
// }